import register from 'preact-custom-element'

class ScaStoreLocator extends HTMLElement {}

// function useAsyncSettingLoading () {
//   const [loadedSetting, setLoadedSetting] = useState(null)
//
//   useEffect(() => {
//     const loadSettingAsync = async () => {
//       await new Promise((resolve) => setTimeout(resolve, 2000))
//       setLoadedSetting(window.SCASLSetting)
//     }
//
//     loadSettingAsync()
//   }, [])
//
//   return loadedSetting
// }

// function SelectComponent ({ id, idContainer, name, className, classContainer, settingKey, defaultSettingKey, settingKeyAppend, additionalOption }) {
//   const loadedSetting = useAsyncSettingLoading()
//
//   return (
//     <>
//       {loadedSetting && (
//         <div id={idContainer} class={classContainer}>
//           <select id={id} name={name} class={className} value={loadedSetting[defaultSettingKey]}>
//             {additionalOption && <option value={additionalOption.value}>{additionalOption.text}</option>}
//             {loadedSetting[settingKey].map((value, index) => (
//               <option key={index} value={value}>
//                 {value} {loadedSetting[settingKeyAppend]}
//               </option>
//             ))}
//           </select>
//         </div>
//       )}
//     </>
//   )
// }

function ScaStorelocatorRadius () {
  return (
    <input
      id='scasl-radius-container'
      name='bh-sl-maxdistance'
      className='input'
      settingKey='radius'
      type='number'
      defaultSettingKey='df_radius'
      settingKeyAppend='df_measurement'
      value='100'
    />
  )
}

register(ScaStorelocatorRadius, 'sca-storelocator-radius')

if (!customElements.get('sca-storelocator')) {
  customElements.define('sca-storelocator', ScaStoreLocator)
}
